import React from "react";
import { Card, CardBody, CardTitle, CardHeader } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const RadialProgressCard = ({
  title = "title",
  percent = 50,
  isSortable = false
}) => {
  return (
    <Card>
      {isSortable && (
        <CardHeader className="p-0 position-relative">
          <div className="position-absolute handle card-icon">
            <i className="simple-icon-shuffle" />
          </div>
        </CardHeader>
      )}
      <CardBody className="d-flex justify-content-between align-items-center">
        <CardTitle className="mb-0">{title}</CardTitle>
        <div className="progress-bar-circle" style={{ width: 60, height: 60 }}>
          <CircularProgressbar
            value={percent}         // ✅ use value instead of percentage
            maxValue={100}          // optional, default 100
            text={`${percent}%`}    // ✅ still valid
            strokeWidth={4}
            styles={buildStyles({
              textSize: "24px",
              textColor: "#000",
              pathColor: "#007bff",
              trailColor: "#d6d6d6"
            })}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default RadialProgressCard;
